import React from 'react'
import { useSelector } from 'react-redux'
import { RouteProp, useRoute } from '@react-navigation/native'
import { NavigationContainer } from '@src/screens/Common/containers'
import { getCoachDescriptor } from '@utils'
import { AppStackParamList } from '@src/navigation/types'
import { userSelector } from '@selectors/app.ts'
import { CoachSwitchComponent } from './CoachSwitchComponent'
import { useCoachSwitch } from './hooks/useCoachSwitch'

export const CoachSwitchModal = () => {
  const user = useSelector(userSelector)
  const coachDescriptor = getCoachDescriptor(user)

  const route = useRoute<RouteProp<AppStackParamList, 'NutritionistSwitchModal'>>()
  const { userInitiated = false } = route.params || {}

  const { dismissNutritionistSwitch } = useCoachSwitch()

  return (
    <NavigationContainer
      title={
        userInitiated
          ? `Switch ${coachDescriptor.capitalized.toString()}`
          : `Confirm New ${coachDescriptor.capitalized.toString()}`
      }
      leftIcon={{ pack: 'eva', name: 'close' }}
      goBack={dismissNutritionistSwitch}
    >
      <CoachSwitchComponent />
    </NavigationContainer>
  )
}
